export const MIN_AMOUNT = 1000;
export const MAX_AMOUNT = 500000;
export const STEP = 1000;

export function sanitiseAmount(raw: string | null | undefined): number | null {
  if (!raw) return null;
  const digits = raw.replace(/[^0-9]+/g, '');
  if (!digits) return null;

  const parsed = Number(digits);
  if (Number.isNaN(parsed)) return null;

  const clamped = Math.min(Math.max(parsed, MIN_AMOUNT), MAX_AMOUNT);
  return Math.round(clamped / STEP) * STEP;
}
